import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
function initials(author: string): string {
  return author.charAt(0).toUpperCase();
}
export function TestimonialsSection() {
  return <section className="defer-paint w-full bg-ink py-12 sm:py-14" aria-labelledby="testimonials-heading" data-id="element-167" data-mp="1mz949hkd4eh0">
      <div className="mx-auto max-w-6xl px-6" data-id="element-168" data-mp="1r02syd5mpxay">
        <div className="mx-auto max-w-2xl text-center" data-id="element-169" data-mp="1d24df4fknutv">
          <p className="eyebrow text-gold" data-id="element-170" data-mp="1d0jj9fx66dwj">En la pista</p>
          <h2 id="testimonials-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.1] text-ivory sm:text-4xl" data-id="element-171" data-mp="1i17lyyurgj6l">
            Qué dicen los entrenadores
          </h2>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-172" data-mp="181zwjdar4y34">
          {testimonials.map(testimonial => <li key={testimonial.author} className="flex h-full flex-col rounded-3xl border border-line bg-coal p-6" data-id="element-173" data-mp="2yeo0gj4qz2b2">
              <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-174" data-mp="32fred038io9n">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-175" data-mp="2uzhurk7slghj" data-mpi={index} />)}
              </div>

              <blockquote className="mt-4 font-sans text-[0.9rem] leading-relaxed text-ivory/85" data-id="element-176" data-mp="34r49vrn93zpk">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto flex items-center gap-3 pt-6" data-id="element-177" data-mp="2zt2pn3e39uci">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gold/30 bg-gold/10 font-display text-base font-bold text-gold" aria-hidden="true" data-id="element-178" data-mp="2c3hw5qkb7eoz">
                  {initials(testimonial.author)}
                </span>
                <span className="font-sans text-sm" data-id="element-179" data-mp="2h1a05iy8ar9j">
                  <span className="block font-semibold text-ivory" data-id="element-180" data-mp="2h0i3s5wt4pi7">
                    {testimonial.author}
                  </span>
                  <span className="block text-xs text-stone" data-id="element-181" data-mp="3sh8ea189k3hm">
                    {testimonial.role} · {testimonial.location}
                  </span>
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}